import React from 'react'

import { Box } from 'ui/components/Box'
import { Button } from 'ui/components/Button'
import { Body } from 'ui/components/Text'

import { useTrashModeToolbarState } from './hooks/useTrashModeToolbarState'

type TrashModeToolbarProps = {}

export const TrashModeToolbar: React.FC<TrashModeToolbarProps> = () => {
    const { onExitTrash, hasRecordsSelected, onRestoreSelected, buttonLabel } =
        useTrashModeToolbarState()

    return (
        <Box width="full" flex center justifyContent="flex-end">
            {hasRecordsSelected && (
                <Button
                    variant="activated"
                    onClick={onRestoreSelected}
                    size="xs"
                    noShrink
                    startIcon={{ name: 'RefreshCcw' }}
                >
                    {buttonLabel}
                </Button>
            )}
            {!hasRecordsSelected && (
                <Box flex center gap="xl">
                    <Body display="block" color="textWeakest" trim shrink>
                        Viewing deleted records from the last 7 days
                    </Body>
                    <Button
                        variant="primary"
                        size="xs"
                        startIcon={{ name: 'Redo2' }}
                        onClick={onExitTrash}
                        noShrink
                    >
                        Exit trash
                    </Button>
                </Box>
            )}
        </Box>
    )
}
